module.exports = __webpack_public_path__ + "assets/img/more-btn-e46a1b3b.png";